import {takeLatest} from 'redux-saga/effects';
import {fetchOTP, handleSignin, handleVerifyOtp} from './handlers/user.handler';
import {generateOTP, signinUser, verifyOtp} from '../slices/user.slice';

export function* watcherSaga() {
    yield takeLatest(signinUser.type, handleSignin);
    yield takeLatest(generateOTP.type, fetchOTP);
    yield takeLatest(verifyOtp.type, handleVerifyOtp);
}
